// data/languages/peul/categories/nourriture.ts

import { CategoryData } from '../../../../types/types';

export const nourriture: CategoryData = {
  // LIQUIDES DE BASE - Termes vérifiés selon les sources
  'Ndiyam': { translation: 'Eau', translationEn: 'Water', illustration: '💧' }, // Terme peul authentique
  'Kosam': { translation: 'Lait', translationEn: 'Milk', illustration: '🥛' },
  'Kosam pennddiɗam': { translation: 'Lait caillé', translationEn: 'Curdled milk', illustration: '🥛' },
    'Gerade': { translation: 'Œuf', translationEn: 'Egg', illustration: '🥚' },
   'Nyibbe': { translation: 'Graine', translationEn: 'Seed', audio: 'Ff-Nyibbe', illustration: '' },
  'Nyibbam': { translation: 'Huile', translationEn: 'Oil', audio: 'Ff-Nyibbam', illustration: '' },
  'Chitta': { translation: 'Poivre', translationEn: 'Pepper', audio: 'Ff-Chitta', illustration: '🌶️' },
  'Manda': { translation: 'Sel', translationEn: 'Salt', audio: 'Ff-Manda', illustration: '' },

  // CÉRÉALES ET FÉCULENTS - Base de l'alimentation peule
  'Gawri': { translation: 'Mil/Sorgho', translationEn: 'Millet/Sorghum', illustration: '🌾' },
  'Marori': { translation: 'Riz', translationEn: 'Rice', audio: 'Ff-Marori', illustration: '🍚' },
  'Butali': { translation: 'Maïs', translationEn: 'Corn', audio: 'Ff-Butali', illustration: '🌽' },

  // PROTÉINES ANIMALES - Essentielles dans l'alimentation
  'Kusel': { translation: 'Viande', translationEn: 'Meat', audio: 'Ff-Kusel', illustration: '🥩' },
  'Liddi': { translation: 'Poisson', translationEn: 'Fish', audio: 'Ff-Liddi', illustration: '🐟' },
  'Njerndi': { translation: 'Œuf', translationEn: 'Egg', illustration: '🥚' },


  // LÉGUMES ET CONDIMENTS

  'Tingere': { translation: 'Oignon', translationEn: 'Onion', audio: 'Ff-Tingere', illustration: '🧅' },





};

export default nourriture;

export {};
